import React from "react";
import { useSelector } from "react-redux";
import { Alert, Chip, FormControl, TextField } from "@mui/material";

import { isValidArray } from "utils/array";
import { addPrefixToString } from "utils/string";
import { isEmailConfig } from "utils/notificationPreference";

import AlertEmailRecipients from "./AlertEmailRecipients";

import {
  CLINIC_NAMES,
  UCH_METRO_MESSAGE_CONTENT,
  ALERT_NOTIFICATION_METHODS,
  ALERT_MESSAGE_CONTENT_LIMIT,
} from "static/constants";

const AlertNotificationGroup = ({
  group,
  message,
  isDisabled,
  selectedRecipients,
  handleRecipientsChange,
  handleMessageChange,
  handleAddNoteToMessage,
}) => {
  const { reportDetail } = useSelector((state) => state.transmission);

  const hasError = !message || message.length > ALERT_MESSAGE_CONTENT_LIMIT;

  return (
    <div
      className="mb-3"
      style={{
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        padding: "16px",
      }}
    >
      {group.configs.map((config) => (
        <React.Fragment
          key={`${group.messageKey}-${config.notification_method}`}
        >
          {config.include_transmission_pdf && (
            <Alert severity="warning" className="mb-4">
              Transmission report PDF will be attached with this{" "}
              {config.notification_method || ""} alert notification.
            </Alert>
          )}

          {isEmailConfig(config) ? (
            <AlertEmailRecipients
              recipients={config.recipients}
              selectedRecipients={selectedRecipients}
              isDisabled={isDisabled}
              onChange={handleRecipientsChange}
            />
          ) : (
            <>
              <div className="text-normal font-weight-bold mb-2">
                {config.notification_method} Recipients:
              </div>

              <div className="d-flex flex-wrap mb-2">
                {isValidArray(config.recipients)
                  ? config.recipients.map((recipient) => (
                      <Chip
                        key={`${config.notification_method}-${recipient}`}
                        label={
                          config.notification_method ===
                          ALERT_NOTIFICATION_METHODS.slack
                            ? addPrefixToString(recipient)
                            : recipient
                        }
                        className="mr-2 mb-2"
                      />
                    ))
                  : "Not added"}
              </div>
            </>
          )}
        </React.Fragment>
      ))}

      <FormControl fullWidth error={hasError} className="mt-2">
        <TextField
          required
          fullWidth
          multiline
          minRows={2}
          maxRows={3}
          label="Message"
          variant="outlined"
          value={message}
          error={hasError}
          helperText={
            (!message && "Message is required.") ||
            (message.length > ALERT_MESSAGE_CONTENT_LIMIT &&
              `Message can have maximum ${ALERT_MESSAGE_CONTENT_LIMIT} characters.`)
          }
          onChange={(e) =>
            handleMessageChange(group.messageKey, e.target.value.trimStart())
          }
          onBlur={() => handleMessageChange(group.messageKey, message.trim())}
          disabled={isDisabled}
        />
      </FormControl>

      {reportDetail?.account === CLINIC_NAMES.UCH_METRO && (
        <div className="d-flex flex-wrap mt-2">
          {UCH_METRO_MESSAGE_CONTENT.map((note, index) => (
            <Chip
              key={`${group.messageKey}-${index}`}
              label={note}
              size="small"
              color="info"
              variant="outlined"
              className="mr-2 mb-2"
              sx={{
                height: "auto",
                "& .MuiChip-label": {
                  display: "block",
                  whiteSpace: "normal",
                },
              }}
              onClick={() => handleAddNoteToMessage(group.messageKey, note)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AlertNotificationGroup;
